const START_OF_DAY_MINUTES = 0
const END_OF_DAY_MINUTES = 24 * 60

// Full day = starts at midnight and ends at 23:59 or 24:00. Missing times mean the
// start/end of the day, which is how the time-blocks table treats them.
export const isFullDayTimeBlock = (
  timeBlock?: { startTime?: number | null; endTime?: number | null } | null,
): boolean => {
  if (!timeBlock) return false

  const start = timeBlock.startTime ?? START_OF_DAY_MINUTES
  const end = timeBlock.endTime ?? END_OF_DAY_MINUTES

  return start === START_OF_DAY_MINUTES && end >= END_OF_DAY_MINUTES - 1 // 1439 (23:59) or 1440
}
